module.exports = __webpack_public_path__ + "img/D201802_1.478e1715.jpg";